export default "__VITE_ASSET__9a033a80__"